/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SetUserGdprConsentResponse
 */
export interface SetUserGdprConsentResponse {
  /**
   *
   * @type {string}
   * @memberof SetUserGdprConsentResponse
   */
  error?: string | null
}

/**
 * Check if a given object implements the SetUserGdprConsentResponse interface.
 */
export function instanceOfSetUserGdprConsentResponse(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function SetUserGdprConsentResponseFromJSON(
  json: any,
): SetUserGdprConsentResponse {
  return SetUserGdprConsentResponseFromJSONTyped(json, false)
}

export function SetUserGdprConsentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetUserGdprConsentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    error: !exists(json, 'error') ? undefined : json['error'],
  }
}

export function SetUserGdprConsentResponseToJSON(
  value?: SetUserGdprConsentResponse | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    error: value.error,
  }
}
